import {NO_OP_ADAPTER} from "@buildwithflux/avatar-logic";
import type {AvatarAdapter} from "@buildwithflux/avatar-logic";
import {createContext, useContext} from "react";
import type {ReactNode} from "react";

const AvatarAdapterContext = createContext<AvatarAdapter>(NO_OP_ADAPTER);

export function useAvatarAdapter(): AvatarAdapter {
    return useContext(AvatarAdapterContext);
}

export function AvatarProvider({adapter, children}: {adapter: AvatarAdapter; children: ReactNode}) {
    return <AvatarAdapterContext.Provider value={adapter}>{children}</AvatarAdapterContext.Provider>;
}
